import { render, staticRenderFns } from "./AddQuestionCard.vue?vue&type=template&id=62d38c50&scoped=true"
import script from "./AddQuestionCard.vue?vue&type=script&lang=js"
export * from "./AddQuestionCard.vue?vue&type=script&lang=js"
import style0 from "./AddQuestionCard.vue?vue&type=style&index=0&id=62d38c50&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d38c50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62d38c50')) {
      api.createRecord('62d38c50', component.options)
    } else {
      api.reload('62d38c50', component.options)
    }
    module.hot.accept("./AddQuestionCard.vue?vue&type=template&id=62d38c50&scoped=true", function () {
      api.rerender('62d38c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/View/NoData/AddQuestionCard.vue"
export default component.exports